export default {

    isOrganisationAdmin(user, organisationId) {

        let organisation = user.organisations.find(x => x.organisation.id === organisationId);
        return user.isGlobalAdmin || organisation?.roleId === 0;
    },

    isOrganisationAdminOrManager(user, organisationId) {

        let organisation = user.organisations.find(x => x.organisation.id === organisationId);
        return user.isGlobalAdmin || organisation?.roleId === 0 || organisation?.roleId === 1;
    },

    isOrganisationProcessor(user, organisationId) {
        let organisation = user.organisations.find(x => x.organisation.id === organisationId);
        return  organisation?.roleId === 2;
    },

    isClientOrClientManagerOrWarden(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && (roleId === 4 || roleId === 5 || roleId === 6);
    },
    
    isClientOrClientManager(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && (roleId === 4 || roleId === 5)
    },

    isClient(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && roleId === 5
    },

    isClientManager(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && roleId === 4
    },

    isWarden(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && roleId === 6
    },

    isThirdPartyProcessor(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && roleId === 8

    },

    isThirdPartyManager(user, organisationId) {
        const roleId = user.organisations.find(item => item.organisation.id === organisationId)?.roleId;
        return roleId !== null && roleId === 9

    }
}